import { useCallback, useState } from 'react';
import { useCancellableRequest } from '../../services/cancellable-request/hook';
import HttpError from '../../services/http-service/HttpError';
import { ApiCall } from '../../services/http-service/types/ApiCall';

const useManualRequest = <CallParams, CallResponse, ModifiedData = undefined>(
  apiCall: ApiCall<CallParams, CallResponse>
) => {
  type HasModifier = ModifiedData extends undefined ? false : true;
  type Data = HasModifier extends true ? ModifiedData : CallResponse;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<HttpError | null>(null);
  const request = useCancellableRequest();

  const fetch = useCallback(
    async (requestParams: CallParams): Promise<Data> => {
      setLoading(true);
      setError(null);
      try {
        const data = await request.send(apiCall, requestParams);
        setLoading(false);
        return data as Data;
      } catch (error) {
        if (HttpError.isHttpError(error)) setError(error);
        setLoading(false);
        return Promise.reject(error);
      }
    },
    [apiCall]
  );

  return {
    loading,
    error,
    trigger: fetch,
    cancel: () => request.cancel(),
  };
};

export default useManualRequest;
